import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { ProcessedOfficer } from '../lib/officerUtils';
interface PacesettersProps {
  officers: ProcessedOfficer[];
  onSelect: (name: string) => void;
}
export function Pacesetters({
  officers,
  onSelect
}: PacesettersProps) {
  const ranked = [...officers].filter(o => o.loginMin > 0).sort((a, b) => b.productionScore - a.productionScore).slice(0, 5);
  return <section className="w-full px-8 lg:px-12 xl:px-16 pb-24" data-id="element-243">
      <div className="border-t border-ink-10 pt-12" data-id="element-244">
        <div className="grid grid-cols-12 gap-10" data-id="element-245">
          <div className="col-span-12 md:col-span-4" data-id="element-246">
            <div className="font-serif font-bold text-xs tracking-[0.28em] uppercase text-primary/70 mb-4" data-id="element-247">
              The Standings
            </div>
            <h2 className="font-serif font-bold text-4xl text-primary leading-tight" data-id="element-248">
              Today's Pacesetters
            </h2>
            <p className="text-sm text-primary/50 mt-4 max-w-xs leading-relaxed font-medium" data-id="element-249">
              Top five loan officers by Production Score — a blend of effort and
              output (leads converted + submissions).
            </p>
          </div>

          <div className="col-span-12 md:col-span-8 divide-y divide-ink-10" data-id="element-250">
            {ranked.map((officer, i) => {
            const isTopThree = i < 3;
            return <motion.button key={officer.name} type="button" onClick={() => onSelect(officer.name)} initial={{
              opacity: 0,
              x: -8
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.4,
              delay: 0.1 + i * 0.08
            }} className="w-full text-left flex items-center gap-6 py-5 group hover:bg-ink-5/40 transition-colors -mx-3 px-3 rounded-sm" data-id="element-251">
                  <span className="font-serif font-bold text-3xl text-primary/30 tabular-nums w-12 group-hover:text-primary transition-colors" data-id="element-252">
                    {String(i + 1).padStart(2, '0')}
                  </span>

                  <div className="flex items-center gap-3 w-56 flex-shrink-0" data-id="element-253">
                    <div className="min-w-0" data-id="element-254">
                      <div className="flex items-center gap-2" data-id="element-255">
                        <span className="text-base text-primary font-bold truncate" data-id="element-256">
                          {officer.name}
                        </span>
                        {isTopThree && <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-signal/10 flex-shrink-0" data-id="element-257">
                            <Check className="w-2.5 h-2.5 text-signal" strokeWidth={3} data-id="element-258" />
                          </span>}
                      </div>
                      <div className="text-xs text-ink-50 tabular-nums mt-0.5" data-id="element-259">
                        {officer.leadsConverted}L · {officer.submissions}S
                      </div>
                    </div>
                  </div>

                  <div className="flex-1 h-px relative" data-id="element-260">
                    <div className="absolute inset-0 h-px bg-ink-10" data-id="element-261" />
                    <motion.div initial={{
                  width: 0
                }} animate={{
                  width: `${officer.productionScore}%`
                }} transition={{
                  duration: 0.8,
                  delay: 0.3 + i * 0.1,
                  ease: 'easeOut'
                }} className="absolute inset-y-0 left-0 bg-signal" style={{
                  height: '2px',
                  top: '-0.5px'
                }} data-id="element-262" />
                  </div>

                  <span className="font-serif font-bold text-2xl text-primary tabular-nums w-20 text-right" data-id="element-263">
                    {officer.productionScore.toFixed(0)}
                  </span>
                </motion.button>;
          })}
          </div>
        </div>
      </div>
    </section>;
}